import http from "@/assets/js/common/http-common";

class MaterialDataService {
  list() {
    return http.get("usuario/materiais");
  }

  create(data) {
    return http.post("usuario/materiais", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  delete(id) {
    return http.delete(`usuario/materiais/${id}/delete`);
  }

  download(id) {
    return http.get(`usuario/materiais/${id}/download`, {
      responseType: "blob",
    });
  }
}

export default new MaterialDataService();
